import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const project = {
    state:{},
    mutations:{},
    actions:{
        async projectlist({},params){//境内、境外项目列表
            const res = await get('/CifitSystem/api/project/projectQuery/projectlist.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getProjectInfo({},params){//获取项目详情
            const res = await get('/CifitSystem/api/project/projectQuery/getProjectInfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getTrade({},params){//获取行业列表
            const res = await get('/CifitSystem/api/project/projectQuery/getTrade.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getProvince({},params){//获取省份列表
            const res = await get('/CifitSystem/api/project/projectQuery/getProvince.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getCity({},params){//获取城市列表
            const res = await get('/CifitSystem/api/project/projectQuery/getCity.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getCountry({},params){//获取国家列表
            const res = await get('/CifitSystem/api/project/projectQuery/getCountry.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async projectQuery({},params){//项目分页查询
            const res = await get('/CifitSystem/api/project/projectQuery/projectQuery.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async investorQuery({},params){//投资商分页查询
            const res = await get('/CifitSystem/api/project/projectQuery/investorQuery.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getInvestorInfo({},params){//投资商详情查询
            const res = await get('/CifitSystem/api/project/projectQuery/getInvestorInfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async profaq({}, params){
            const res = await get('/CifitSystem/api/projectDocking/ProjectDockingFAQ/getList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async relatedWebsite({}, params){
            const res = await get('/CifitSystem/api/projectDocking/relatedWebsite/list.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default project


// WEBPACK FOOTER //
// ./src/store/modules/project.js